import React, { PropsWithChildren, useEffect } from 'react';
import { useNetwork } from '../../hooks/useNetwork';
import Offline from '../Offline';
import { initSocket } from 'shared/utils/initSocket';

interface RequireNetworkProps { }

const RequireNetwork = ({
  children,
}: PropsWithChildren<RequireNetworkProps>) => {
  const {
    networkStatus: { isOnline },
  } = useNetwork();

  const handleTabChange = () => {
    if (document.hidden) {
      console.log("Document is hidden")
    } else {
      console.log("Document is active")
    }
    const token = localStorage.getItem('user');
    // initSocket(token)
  }

  useEffect(() => {
    if (isOnline !== undefined) {
      console.log("Online status changed ", isOnline)
      const token = localStorage.getItem('user');
      // initSocket(token)
    }

    document.addEventListener("visibilitychange", handleTabChange);

    return () => {
      document.removeEventListener("visibilitychange", handleTabChange);
    };

  }, [isOnline])

  return (
    <div>
      <Offline isOffline={!isOnline} />
      {children}
    </div>
  );
};

export default RequireNetwork;
